
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";

interface Situation {
  key: string;
  icon: string;
  // Zero-based indices of conversation starters after which the prototype leaves a visual gap.
  gapsAfter: number[];
}

const SVG_ATTRS = 'viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';

// Situations are fixed by design; all copy comes from literals (NextSteps::Sit::<key>::*).
// Step / question / action counts are discovered from the literals, so the literals team can
// add or remove items without a code change.
const SITUATIONS: Situation[] = [
  { key: "forming", icon: `<svg ${SVG_ATTRS}><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/></svg>`, gapsAfter: [0, 3, 5, 6] },
  { key: "conflict", icon: `<svg ${SVG_ATTRS}><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>`, gapsAfter: [5] },
  { key: "onboarding", icon: `<svg ${SVG_ATTRS}><circle cx="9" cy="8" r="3.2"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0M18 8v6M15 11h6"/></svg>`, gapsAfter: [] },
  { key: "shift", icon: `<svg ${SVG_ATTRS}><path d="M3 12h4l3-8 4 16 3-8h4"/></svg>`, gapsAfter: [] },
  { key: "pressure", icon: `<svg ${SVG_ATTRS}><path d="M12 3a9 9 0 0 1 9 9M12 12l5-3.5M5.6 18.4a9 9 0 0 1 12.8 0"/><circle cx="12" cy="12" r="1.4"/></svg>`, gapsAfter: [] },
];

const MAX_ITEMS = 20;

@Component
export default class NextStepsTab extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ default: false }) readonly printing!: boolean;

  public activeIndex = 0;

  get situations(): Situation[] {
    return SITUATIONS;
  }

  get recCount(): number {
    return this.countKeys((n) => `NextSteps::Rec::${n}::Title`);
  }

  stepCount(key: string): number {
    return this.countKeys((n) => `NextSteps::Sit::${key}::Step::${n}::Title`);
  }

  questionCount(key: string): number {
    return this.countKeys((n) => `NextSteps::Sit::${key}::Q::${n}`);
  }

  actionCount(key: string): number {
    return this.countKeys((n) => `NextSteps::Sit::${key}::Action::${n}`);
  }

  // Number of consecutive 1-based keys that exist in the literals dictionary.
  private countKeys(keyFor: (n: number) => string): number {
    let n = 0;
    while (n < MAX_ITEMS && this.$te(keyFor(n + 1))) n += 1;
    return n;
  }
}
